import {FunctionComponent, useState} from 'react';
import classnames from 'classnames';
import {
  Nav,
  NavItem,
  NavLink,
  TabPane,
  TabContent,
} from 'reactstrap';

import {
  TabProps,
  TabListProps,
} from './types';

import './styles.css';

export const TabList = ({onTabChange, tabs}: TabListProps) => {
  const [activeTab, setActiveTab] = useState(0);

  const updateActiveTab = (tabNumber: number) => {
    onTabChange && onTabChange({
      prev: tabs[activeTab],
      next: tabs[tabNumber],
    });
    setActiveTab(tabNumber);
  };

  const Tab: FunctionComponent<TabProps> = ({tabNumber, children}) => {
    return (
      <NavItem className="NavItem">
        <NavLink
          className={classnames({
            NavLink: true,
            active: tabNumber === activeTab,
          })}
          onClick={() => updateActiveTab(tabNumber) }
        >
          {children}
        </NavLink>
      </NavItem>
    );
  };

  return (
    <>
      <Nav className="TabList" tabs>
        {tabs.map(({tab}, i) =>
          <Tab key={i} tabNumber={i}>{tab}</Tab>,
        )}
      </Nav>
      <TabContent activeTab={activeTab}>
        {tabs.map(({pane}, i) =>
          <TabPane className="TabList--pane" key={i} tabId={i}>
            {pane}
          </TabPane>,
        )}
      </TabContent>
    </>
  );
};
